import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=1546d4cc&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1546d4cc')) {
      api.createRecord('1546d4cc', component.options)
    } else {
      api.reload('1546d4cc', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=1546d4cc&", function () {
      api.rerender('1546d4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a5wxohQ4zPX9/JS/cancellationPolicy.vue"
export default component.exports